import { I18n } from "@assets/strings";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useServices } from "@core/servicesContext";
import { useCurrentProfile } from "@domain/currentProfile/hooks";
import { getLivecourseInfos, useParticipants } from "@domain/livecourse/hooks";
import { LivecourseType } from "@domain/livecourse/livecourse";
import { AlreadyJoinButton } from "@ui/pages/livecourses/livecoursesThumbnail";
import { createToast } from "@ui/toasts/utils";
import { PrimaryButton } from "@ui/components/buttons/primaryButton";

interface NotificationJoinButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
	liveCourseId: string;
}
export const NotificationJoinButton: React.FC<NotificationJoinButtonProps> = ({ liveCourseId }) => {
	const currentProfile = useCurrentProfile();
	const [joined, setJoined] = useState(false);
	const { livecourseService } = useServices();
	const { result: livecourse } = getLivecourseInfos(liveCourseId);
	const [isCreator, setIsCreator] = useState(
		currentProfile && livecourse && currentProfile.id === livecourse.organizer
	);
	const { result: members, fetch } = useParticipants(liveCourseId);
	useEffect(() => {
		{
			const joined = !!currentProfile && members.map((mb) => mb.id).includes(currentProfile.id);

			setJoined(joined);
			setIsCreator(currentProfile && livecourse && currentProfile.id === livecourse.organizer);
		}
	}, [currentProfile, members]);
	const type = livecourse ? livecourse.type : undefined;

	if (!livecourse) return <></>;
	return !isCreator ? (
		joined && type === LivecourseType.INSTANT ? (
			<JoinButton>
				<PrimaryButton
					onClick={async () => {
						try {
							const { participationLink } = await livecourseService.confirm(livecourse.id);
							if (type === LivecourseType.INSTANT && participationLink) global.window.location.href = participationLink;
							fetch();
						} catch {
							createToast(I18n.t("errormessage"), I18n.t("live.declined"), "error");
						}
					}}
				>
					{I18n.t("live.join")}
				</PrimaryButton>
			</JoinButton>
		) : joined && type === LivecourseType.SCHEDULED ? (
			<AlreadyJoinButton>{I18n.t("live.confirmed")}</AlreadyJoinButton>
		) : !joined ? (
			<JoinButton>
				<PrimaryButton
					onClick={async () => {
						try {
							const { participationLink } = await livecourseService.confirm(livecourse.id);
							createToast(I18n.t("success"), I18n.t("live.confirmed"), "success");
							setJoined(true);
							fetch();
							if (type === LivecourseType.INSTANT && participationLink) global.window.location.href = participationLink;
						} catch {
							createToast(I18n.t("errormessage"), I18n.t("live.declined"), "error");
						}
					}}
				>
					{type === LivecourseType.INSTANT ? I18n.t("live.join") : I18n.t("live.joininstantroom")}
				</PrimaryButton>
			</JoinButton>
		) : (
			<></>
		)
	) : (
		<></>
	);
};

const JoinButton = styled.div`
	position: relative;
	font-family: Sora;
	margin-top: 12px;
	${({ theme }) => theme.colors.primary};
	font-size: 13px;
	font-weight: 100;
	justify-content: center;
	align-items: center;
`;
